module.exports = __webpack_public_path__ + "static/media/baxodir.d43edc96.jpg";